"use strict";
var forms_1 = require('@angular/forms');
var lang_1 = require('../facade/lang');
exports.gt = function (gt) {
    return function (control) {
        if (!lang_1.isPresent(gt))
            return null;
        if (lang_1.isPresent(forms_1.Validators.required(control)))
            return null;
        var v = +control.value;
        return v > +gt ? null : { gt: true };
    };
};
//# sourceMappingURL=validator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-validation/dist/greater-than/validator.js
// module id = 1236
// module chunks = 7